import { Anchor, Card, Flex, Hr, P, Tag, Tooltip } from '@dnb/eufemia';
import { Link } from 'react-router-dom';

import ApiFavouriteButton from '@/components/ApiFavouriteButton';
import { useUser } from '@/hooks/useUser';
import type { McpWithUserDataResponse } from '@/openapi/schema';
import ApiStageBadge from '@/pages/profile/components/ApiStageBadge';
import { capitalizeFirstLetterOfString } from '@/utils/textUtils';

import style from './index.module.css';

export type McpItem = McpWithUserDataResponse;

interface McpCardProps {
  mcp: McpItem;
  onMcpFavouriteChange: (mcpId: string, isFavorite: boolean) => void;
}

const DESCRIPTION_LIMIT = 200;

function getMcpTags(mcp: McpItem): string[] {
  return mcp.tags;
}

function limitDescription(text: string): string {
  if (text.length < DESCRIPTION_LIMIT) return text;
  return `${text.slice(0, DESCRIPTION_LIMIT)}...`;
}

export default function McpCard({ mcp, onMcpFavouriteChange }: McpCardProps) {
  const { user } = useUser();
  const tags = getMcpTags(mcp);

  return (
    <Card stack>
      <Flex.Horizontal justify="space-between">
        <Flex.Container>
          <Anchor element={Link} to={`/mcp-servers/${mcp.slug}/@default/@latest/guide`}>
            {mcp.name}
          </Anchor>
          <ApiStageBadge compact stage={mcp.stage} />
        </Flex.Container>
        {user && <ApiFavouriteButton apiId={mcp.id} isFavorite={mcp.isFavorite} onChange={onMcpFavouriteChange} />}
      </Flex.Horizontal>

      <P className={mcp.description ? undefined : style['no-description']} size="small" top="small">
        {mcp.description ? limitDescription(mcp.description) : 'No description'}
      </P>
      <Hr bottom="x-small" className={style['Divider']} top="small" />
      <Tag.Group label="MCP classification and tags">
        <Tooltip
          targetElement={
            <Tag className={style['classificationTag']}>
              {capitalizeFirstLetterOfString(mcp.classification.toLowerCase())}
            </Tag>
          }
        >
          Classification
        </Tooltip>
        {tags.map((tag) => (
          <Tag key={tag}>{tag}</Tag>
        ))}
      </Tag.Group>
    </Card>
  );
}
